import PropTypes from 'prop-types';
import React from 'react';

import {
  propTypesAltLanguage,
  propTypeslocalization,
} from '../../../../constants/Proptypes';
import { propTypesNavigation } from '../Header.proptypes';

import Button, { ButtonAppearance } from '../../../../../ui/Atoms/Button';
import LanguageSelect from '../../../../../ui/Molecules/LanguageSelect';
import { BlogNavBar } from './BlogNavBar';
import { NavBarButtons } from './NavBarButtons';
import { SearchBar } from './SearchBar';
import { WebsiteNavBar } from './WebsiteNavBar';

import { DocumentType } from '../../../../constants/Enums';
import * as S from './NavBar.styles';

export const NavBar = ({
  isMobile,
  isVisible,
  isSearchBarDisplayed,
  setIsSearchBarDisplayed,
  placeholder,
  document,
  alternateLanguages,
  lang,
  documentType,
  localization,
}) => {
  const hasBlogNavigation =
    documentType === 'blog' && (!isSearchBarDisplayed || isMobile);
  const hasSearchBar = documentType === 'blog' || documentType === 'event';

  const {
    additional_label: additionalLabel,
    additional_link: { url: additionalUrl, target: additionalTarget } = {},
    additional_datatrack: additionalDataTrack,
  } = document || '';

  return (
    <S.MainNav isMobile={isMobile} isVisible={isVisible}>
      <S.MenuLink
        isMobile={isMobile}
        isSearchBarDisplayed={isSearchBarDisplayed}
      >
        {hasBlogNavigation && (
          <BlogNavBar document={document} isMobile={isMobile} />
        )}
        {documentType === 'website' && (
          <WebsiteNavBar document={document} isMobile={isMobile} />
        )}
        {documentType === 'website' && additionalLabel && additionalUrl && (
          <Button
            appearance={ButtonAppearance.MINIMAL}
            target={additionalTarget}
            dataTrackAttribute={additionalDataTrack}
            link={additionalUrl}
          >
            {additionalLabel}
          </Button>
        )}
        {hasSearchBar && (
          <SearchBar
            isMobile={isMobile}
            isSearchBarDisplayed={isSearchBarDisplayed}
            setIsSearchBarDisplayed={setIsSearchBarDisplayed}
            placeholder={placeholder}
            lang={lang}
            isEvent={documentType === 'event' ? true : false}
          />
        )}
        {!isMobile && (
          <NavBarButtons
            document={document}
            documentType={documentType}
            localization={localization}
          />
        )}
        <LanguageSelect
          alternateLanguages={alternateLanguages}
          isMobile={isMobile}
          lang={lang}
        />
        {isMobile && (
          <NavBarButtons
            document={document}
            documentType={documentType}
            localization={localization}
          />
        )}
      </S.MenuLink>
    </S.MainNav>
  );
};

NavBar.propTypes = {
  isMobile: PropTypes.bool,
  isVisible: PropTypes.bool,
  isSearchBarDisplayed: PropTypes.bool,
  setIsSearchBarDisplayed: PropTypes.func,
  placeholder: PropTypes.string,
  document: PropTypes.shape(propTypesNavigation.data),
  alternateLanguages: PropTypes.arrayOf(PropTypes.shape(propTypesAltLanguage)),
  lang: PropTypes.string,
  documentType: PropTypes.oneOf(Object.values(DocumentType)),
  localization: PropTypes.shape(propTypeslocalization),
};
